import { Heading } from "@chakra-ui/react"
import CustomerStatusChangeHandler from "../../containers/mixedHandlers/cardOperations/CustomerStatusChangeTableHandler"

const CustomerStatusChangePage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>Changement Statut Client</Heading>
      <CustomerStatusChangeHandler />
    </>
  )
}

export default CustomerStatusChangePage